var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","width":"100%","padding-top":"100px","font-size":"large"}},[_vm._v(" 欢迎使用搬家上货! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }